<template>
  <div>
    <div class="help-header">
      <div class="container">
        <h1>Ayuda</h1>
      </div>
    </div>
    <div class="help-grid container">
      <details>
        <summary>Declaración de Accesibilidad</summary>
        <p>Conahcyt tiene el compromiso de facilitar el uso y acceso a la información al mayor número de público posible. Nuestro sitio web cuenta con diversos recursos de accesibilidad apegados a las estrategias, estándares y recursos de Apoyo de la Iniciativa para la Accesibilidad Web* (WAI por sus siglas en inglés) y continuamos trabajando en ello. Los recursos de accesibilidad con los que contamos son:</p>
        <ul class="ul-lista">
          <li>Navegación por teclado</li>
          <li>Accesibilidad de lectores de pantalla para describir el contenido que estamos navegando en el sitio</li>
          <li>Paleta de color para facilitar la lectura para personas que padecen la mayoría de las variantes de daltonismo</li>
          <li>Tamaño y contraste de texto legible para personas que tienen dificultades de visión</li>
          <li>Contenido que puede aumentarse el tamaño utilizando los controles estándar de los navegadores</li>
        </ul>
        <p>Si tienes algún comentario o sugerencia relacionada con la accesibilidad de nuestro sitio ponte en contacto tus comentarios ayudarán a mejorar y facilitar el acceso a la información.</p>
      </details>
      <details>
        <summary>Navegación por medio del teclado</summary>
        <dl class="dl-glosario">
          <dt>Tabulador (Tab)</dt>
          <dd>Carga la página, luego comienza a presionar la tecla de tabulación. El foco del teclado (color azul) debe moverse cada elemento interactivo de la página.</dd>
          <dt>Shift + Tab</dt>
          <dd>Hace lo mismo que usar la tecla de tabulación, pero en sentido inverso.</dd>
          <dt>Entrar / Volver</dt>
          <dd>Si activas esta función (presionar la tecla), abrirá el enlace en cuestión.</dd>
          <dt>Barra espaciadora</dt>
          <dd>Alterna los valores de las casillas de verificación, activa los botones.</dd>
          <dt>Teclas de flecha</dt>
          <dd>Desplaza contenido, mueve o selecciona botones de radio dentro de un grupo.</dd>
        </dl>
      </details>
      <details>
        <summary>Plugins de lectura</summary>
        <ul class="ul-lista">
          <li>Android Accessibility Suite</li>
          <li>Job Access With Speech (JAWS)</li>
          <li>NonVisual Desktop Access</li>
          <li>Orca</li>
          <li>VoiceOver (iOS)</li>
          <li>VoiceOver (macOS)</li>
          <li>Emacspeak (Linux)</li>
          <li>Spoken Web (Internet Explorer)</li>
          <li>ChromeVox (Google Chrome)</li>
        </ul>
        <p>Otros para ayudar a personas que no han perdido completamente la vista son para agrandar el texto y agregar contraste</p>
        <ul>
          <li>A+ FontSize Changer Lite (Chrome)</li>
          <li>Zoom Page WE (Firefox)</li>
        </ul>
      </details>
      <details open>
        <summary>Glosario de términos</summary>
        <dl class="dl-glosario">
          <dt>Agroquímicos:</dt>
          <dd>Los agroquímicos son sustancias químicas que se emplean en forma recurrente en la agricultura con la finalidad de mantener y conservar los cultivos que esta actividad desarrolla. Normalmente su uso está vinculado a la intención de proporcionarles nutrientes a los cultivos, matar insectos o cualquier otro organismo que los afecte de manera negativa y también para eliminar las malezas y los hongos.</dd>
          <dt>Agrotóxicos:</dt>
          <dd>Se trata de sustancias nocivas para las tierras cultivadas y dañinas para la salud humana. El uso de las mismas se ha generalizado en todo el planeta y su principal finalidad es combatir las plagas de animales que ponen en peligro los cultivos. </dd>
          <dt>Glifosato:</dt>
          <dd>Herbicida que impide el crecimiento de la maleza, es decir, las malas hierbas, actúa como un inhibidor de una enzima vegetal esencial para el metabolismo de las plantas. El glifosato se empezó a utilizar en la década de 1970 y a partir de los años 90 se ha generalizado su uso en la agricultura.</dd>
          <dt>Herbicida:</dt>
          <dd>Sustancia química que mata los órganos vegetales de las plantas. Generalmente, se trata de preparados compuestos de sustancias tóxicas. Son productos destinados a combatir la maleza o malas hierbas. Herbicida quiere decir “lo que mata las plantas o hierbas”, pues el sufijo “cida” significa matar ( ejemplo la palabra homicida o suicida).</dd>
          <dt>Repositorio de investigación:</dt>
          <dd>Plataforma digital que proporciona acceso abierto a diversos recursos de información académica, científica y tecnológica, es un medio de acceso público a la información e investigación relacionada a uno o diversos temas.</dd>
          <dt>Unidad de producción:</dt>
          <dd>Es la unidad económica conformada por uno o más terrenos ubicados en un mismo municipio, en donde al menos en alguno de ellos se realizan actividades agropecuarias, bajo el control de una misma administración.</dd>
        </dl>
      </details>
      <details open>
        <summary>Glosario de abreviaturas</summary>
        <ul class="ul-glosario">
          <li v-for="estado in estados" :key="estado.id">
            <b>{{estado.abre}}</b> {{estado.nom_edo}}
          </li>
        </ul>
      </details>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      estados: [
        {
          "id": "01",
          "nom_edo": "Aguascalientes",
          "abre": "Ags."
        },
        {
          "id": "02",
          "nom_edo": "Baja California",
          "abre": "B.C."
        },
        {
          "id": "03",
          "nom_edo": "Baja California Sur",
          "abre": "B.C.S."
        },
        {
          "id": "04",
          "nom_edo": "Campeche",
          "abre": "Camp."
        },
        {
          "id": "05",
          "nom_edo": "Coahuila de Zaragoza",
          "abre": "Coah."
        },
        {
          "id": "06",
          "nom_edo": "Colima",
          "abre": "Col."
        },
        {
          "id": "07",
          "nom_edo": "Chiapas",
          "abre": "Chis."
        },
        {
          "id": "08",
          "nom_edo": "Chihuahua",
          "abre": "Chih."
        },
        {
          "id": "09",
          "nom_edo": "Ciudad de México",
          "abre": "CDMX"
        },
        {
          "id": "10",
          "nom_edo": "Durango",
          "abre": "Dgo."
        },
        {
          "id": "11",
          "nom_edo": "Guanajuato",
          "abre": "Gto."
        },
        {
          "id": "12",
          "nom_edo": "Guerrero",
          "abre": "Gro."
        },
        {
          "id": "13",
          "nom_edo": "Hidalgo",
          "abre": "Hgo."
        },
        {
          "id": "14",
          "nom_edo": "Jalisco",
          "abre": "Jal."
        },
        {
          "id": "15",
          "nom_edo": "México",
          "abre": "Edo Mx."
        },
        {
          "id": "16",
          "nom_edo": "Michoacán de Ocampo",
          "abre": "Mich."
        },
        {
          "id": "17",
          "nom_edo": "Morelos",
          "abre": "Mor."
        },
        {
          "id": "18",
          "nom_edo": "Nayarit",
          "abre": "Nay."
        },
        {
          "id": "19",
          "nom_edo": "Nuevo León",
          "abre": "N.L."
        },
        {
          "id": "20",
          "nom_edo": "Oaxaca",
          "abre": "Oax."
        },
        {
          "id": "21",
          "nom_edo": "Puebla",
          "abre": "Pue."
        },
        {
          "id": "22",
          "nom_edo": "Querétaro",
          "abre": "Qro."
        },
        {
          "id": "23",
          "nom_edo": "Quintana Roo",
          "abre": "QRoo."
        },
        {
          "id": "24",
          "nom_edo": "San Luis Potosí",
          "abre": "S.L.P."
        },
        {
          "id": "25",
          "nom_edo": "Sinaloa",
          "abre": "Sin."
        },
        {
          "id": "26",
          "nom_edo": "Sonora",
          "abre": "Son."
        },
        {
          "id": "27",
          "nom_edo": "Tabasco",
          "abre": "Tab."
        },
        {
          "id": "28",
          "nom_edo": "Tamaulipas",
          "abre": "Tamps."
        },
        {
          "id": "29",
          "nom_edo": "Tlaxcala",
          "abre": "Tlax."
        },
        {
          "id": "30",
          "nom_edo": "Veracruz de Ignacio de la Llave",
          "abre": "Ver."
        },
        {
          "id": "31",
          "nom_edo": "Yucatán",
          "abre": "Yuc."
        },
        {
          "id": "32",
          "nom_edo": "Zacatecas",
          "abre": "Zac."
        }
      ]
    }
  },
};
</script>

<style scoped lang="scss">
@keyframes openDetails {
  0% {
    border-right-color: #fff;
    width: 99.9%;
    opacity: .1;
    order: -1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes closeDetails {
  0% {
    opacity: .1;
  }
  100% {
    border-right-color: #ddd;
    width: 33.3%;
    opacity: 1;
    order: inherit;
  }
}

.help-header {
  background: #f4f4f4;
  padding: $space 0;
  @media (min-width: $breakpoint-tablet) {
    margin-bottom: $space * 2;
  }
}

.help-grid {
  details {
    font-size: 0;
    padding: $space 0;
    border-bottom: 1px solid #ddd;
    transition: font-size .2s ease-in-out;
    summary {
      display: flex;
      align-content: center;
      justify-content: space-between;
      font-size: 1.25rem;
      line-height: 1.2em;
      font-weight: 600;
      cursor: pointer;
      transition: font-size .2s ease-in-out;
      &:hover,
      &:focus {
        outline: none;
      }
      &::after {
        content: "";
      }
    }
    summary::marker {
      content: "";
    }
    &[open] {
      font-size: .85rem;
      summary {
        font-size: 1.7rem;
      }
    }
  }
  @media (min-width: $breakpoint-tablet) {
    box-sizing: border-box;
    margin-bottom: $space * 2;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    position: relative;
    transition: all 1s ease-in-out;
    &::after {
      background: #fff;
      content: " ";
      display: block;
      height: 1px;
      width: 100%;
      position: relative;
      top: -1px;
      z-index: 1;
    }
    &::before {
      background: #fff;
      content: " ";
      display: block;
      width: 1px;
      position: absolute;
      right: 1px;
      top: 0;
      bottom: 0;
      z-index: 1;
    }
    details {
      background: #fff;
      border-right: 1px solid #ddd;
      box-sizing: border-box;
      width: 33.3%;
      padding: $space;
      animation: closeDetails .5s ease-in-out forwards;
      > * {
        max-width: 600px;
      }
      &[open] {
        animation: openDetails .5s ease-in-out forwards;
        width: 99.9%;
        opacity: 1;
        order: -1;
      }
    }
  }
}

.ul-lista {
  list-style: none;
  padding-left: $space;
  li {
    margin: 0 0 $space*.25 0;
    &::before {
      content: " ";
      background: $verde-claro;
      border-radius: 10px;
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 10px;
      margin-left: - #{$space*.5};
    }
  }
}

.dl-glosario {
  dt {
    font-weight: 600;
  }
  dd {
    margin: 0 0 $space*.5 0;
  }
}

.ul-glosario {
  @media (min-width: $breakpoint-tablet) {
    column-count: 2;
    column-gap: $space;
  }
  b {
    display: inline-block;
    font-weight: 600;
    margin-right: $space*.25;
    text-transform: uppercase;
  }
}
</style>
